import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const CoursePrice = (props) => {
  console.log(props);
  if (props.state.payment.paymentOption === 'instalments') {
    return (
      <span>
        £{props.state.course.instalmentPrice * props.state.course.instalmentDurationMonths} ({props.state.course.instalmentDurationMonths} instalments of £{props.state.course.instalmentPrice})
      </span>
    )
  } else {
    return (
      <span>
        £{props.state.course.price}
      </span>
    )
  }
}
const DatPageFooter = (props) => {
  return (
    <div className='form-footer'>
      <p className='error-message' style={{display: 'block', fontSize: '24px'}}>{props.checkoutState.serverError}</p>
      <div className='checkout__authorize'>
        <button
          onClick={props.onDatSubmit}
          className={'button button--xl button--shadow ' + (props.isLoading ? 'is-loading' : '')}
          disabled={props.isLoading}>
          Confirm &amp; Pay
        </button>
        <p className='cta-extra'>By clicking on the 'Confirm' button you agree to our  <a href='https://s3-eu-west-1.amazonaws.com/static.bslcourses.co.uk/pdfs/bsl-terms.pdf' target='_blank' rel='noopener noreferrer'>Terms</a> and <a href='/static/bsl-pdfs/bsl-privacy.pdf' target='_blank' rel='noopener noreferrer'>Privacy Policy</a> and have read the <a href='/static/bsl-pdfs/bsl-requirements.pdf' target='_blank' rel='noopener noreferrer'>Course Requirements</a></p>
      </div>
      <div className='checkout__security'>
        <div>
          <h4>What happens next?</h4>
          <p>your card will be charged £{props.checkoutState.course.price}. You will be able to start your course immediately. </p>
        </div>
        <div>
          <h4>Security</h4>
          <p>Payments are processed using Stripe which uses PCI-compliant bank-level security to keep your details safe. We will never share your details with any third parties.</p>
        </div>
      </div>
    </div>
  );
};

/* -- for when there was a waiting list
const WaitingPageFooter = (props) => {
  return (
    <div className='form-footer'>
      <p className='error-message' style={{display: 'block', fontSize: '24px'}}>{props.checkoutState.serverError}</p>
      <div className='checkout__authorize'>
        <button
          onClick={props.onWaitingSubmit}
          className={'button button--xl button--shadow ' + (props.isLoading ? 'is-loading' : '')}
          disabled={props.isLoading}>
          Confirm
        </button>
        <p className='cta-extra'>By clicking on the 'Confirm' button you agree to our  <a href='/static/bsl-pdfs/bsl-terms.pdf' target='_blank'>Terms</a> and <a href='/static/bsl-pdfs/bsl-privacy.pdf' target='_blank'>Privacy Policy</a> and have read the <a href='/static/bsl-pdfs/bsl-requirements.pdf' target='_blank'>Course Requirements</a></p>
      </div>
      <div className='checkout__security'>
        <div>
          <h4>What happens next?</h4>
          <p>An invoice will be emailed to you but you are not required to pay until a space on your course becomes available (currently 1 month). You will be notified when this happens.</p>
        </div>
      </div>
    </div>
  );
}; -- */

const CustomerDetails = (props) => {
  if (props.customer.name !== '' && props.customer.email !== '') {
    return (
      <div className='checkout__confirm-section'>
        <h3 className=''>Your details</h3>
        <p>
          <strong>Name: </strong> {props.customer.name}<br />
          <strong>Email: </strong> {props.customer.email}
        </p>
        <Link to='/checkout/register'>edit</Link>
      </div>
    );
  } else {
    return null;
  }
};

const PaymentDetails = (props) => {
  return (
    <span>
      <strong>Payment details: </strong> {props.checkoutState.payment.cardType} (ending {props.format4digits()})<br />
    </span>
  );
};

class Confirm extends Component {
  constructor (props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.getMeaningfulPaymentType = this.getMeaningfulPaymentType.bind(this);
    this.format4digits = this.format4digits.bind(this);
    this.state = {
      isLoading: false
    };
  }

  getMeaningfulPaymentType (type) {
    if (type === 'stripe') {
      return 'Card';
    }
    return 'Invoice';
  }

  format4digits () {
    const number = this.props.checkoutState.payment.number;
    return number.substr(number.length - 4);
  }

  handleSubmit () {
    let newState = this.state;
    newState.isLoading = true;
    this.setState(newState);
    this.props.onSubmit(4);
  }

  componentWillReceiveProps () {
    let newState = this.state;
    newState.isLoading = false;
    this.setState(newState);
  }

  handleFormSubmit (e) {
    // WATCH OUT FOR THIS... if the form has no handler it will submit in
    // the beackground and break the CORS POST with silent failing
    e.preventDefault();
  }

  render () {
    const paymentDetails = <PaymentDetails checkoutState={this.props.checkoutState} format4digits={this.format4digits} />;
    const pageFooter = <DatPageFooter
      checkoutState={this.props.checkoutState}
      onDatSubmit={this.handleSubmit}
      isLoading={this.state.isLoading} />;

    /* -- for when there was a waiting list
    let pageFooter;
    let paymentDetails = null;
    if (this.props.checkoutState.course.type === 'independent' ||
    this.props.checkoutState.course.title.indexOf('Level 1') > -1) {
      paymentDetails = <PaymentDetails checkoutState={this.props.checkoutState} format4digits={this.format4digits} />;
      pageFooter = <DatPageFooter
        checkoutState={this.props.checkoutState}
        onDatSubmit={this.handleSubmit}
        isLoading={this.state.isLoading}
      />;
    } else {
      pageFooter = <WaitingPageFooter
        checkoutState={this.props.checkoutState}
        onWaitingSubmit={this.handleSubmit}
        isLoading={this.state.isLoading}
      />;
    } -- */

    return (
      <form action='' className='checkout__form' onSubmit={this.handleFormSubmit}>
        <h2>Confirm</h2>
        <p>Check the details below then click confirm</p>
        <div className='checkout__confirm-section'>
          <h3 className=''>Your chosen course</h3>
          <p>
            <strong> {this.props.checkoutState.course.title}</strong><br />
            <strong>Type:</strong> {this.props.checkoutState.course.type}<br />
            <strong>Duration:</strong> {this.props.checkoutState.course.duration} weeks<br />
            <strong>Course price:</strong> <CoursePrice state={this.props.checkoutState} />
          </p>
          <Link to='/courses'>edit</Link>
        </div>
        <CustomerDetails customer={this.props.checkoutState.customer} />
        <div className='checkout__confirm-section checkout__confirm-section--payment'>
          <h3 className=''>Payment details</h3>
          <p>
            <strong>Payment type: </strong>
            {this.getMeaningfulPaymentType(this.props.checkoutState.payment.paymentType)}&nbsp;({this.props.checkoutState.payment.paymentOption})
            <br />
            {paymentDetails}
            <strong>Total to pay: </strong> <CoursePrice state={this.props.checkoutState} />
          </p>
          <Link to='/checkout/payment-details'>edit</Link>
        </div>
        {pageFooter}
      </form>
    );
  }
}

Confirm.propTypes = {
  checkoutState: PropTypes.object,
  onSubmit: PropTypes.func.isRequired
};

export default Confirm;



// WEBPACK FOOTER //
// ./src/views/Checkout/Confirm/index.js